export const onDeleteProp = (id, dist) => ({
  widget: 'models',
  type: 'onDeleteProp',
  payload: { id, dist },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDeleteProp.js